import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class VerifyLoginBuilder {
  constructor(private _translateService: TranslateService) {}

  buildTitle(success: boolean) {
    const translationKey = success ? 'SUCCESS' : 'FAIL';

    return this._translateService.instant(
      `VERIFY_LOGIN.${translationKey}.TITLE`
    );
  }

  buildSubTitle(success: boolean) {
    const translationKey = success ? 'SUCCESS' : 'FAIL';

    return this._translateService.instant(
      `VERIFY_LOGIN.${translationKey}.SUB_TITLE`
    );
  }
}
